import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import { PaperProps } from '@mui/material/Paper'
import { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCanNavigateTo } from '../../hooks/useCanNavigateTo'

type AppCardGridProps = {
  name: string
  description: string
  icon: ReactNode
  color: string
  path: string
} & PaperProps

export const AppCardGrid: FC<AppCardGridProps> = ({ name, description, icon, color, path, ...paperProps }) => {
  const navigate = useNavigate()
  const canNavigateTo = useCanNavigateTo()

  if (!canNavigateTo(path)) return null

  return (
    <Grid>
      <Paper
        onClick={() => navigate(path)}
        sx={{
          overflow: 'hidden',
          borderRadius: 'var(--border-radius-xl)',
          width: '18rem',
          cursor: 'pointer',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
        {...paperProps}
      >
        <Box sx={{ backgroundColor: color, p: 'var(--spacing-m)' }}>{icon}</Box>
        <Stack sx={{ p: 'var(--spacing-m)', backgroundColor: 'var(--bg-surface)', flex: 1 }} spacing={'1rem'}>
          <Typography sx={{ color: 'var(--text-primary)', fontSize: '1.75rem', lineHeight: '2rem', fontWeight: '600' }} component={'h2'}>
            {name}
          </Typography>
          <Typography sx={{ color: 'var(--text-secondary)' }}>{description}</Typography>
        </Stack>
      </Paper>
    </Grid>
  )
}
